import { render, staticRenderFns } from "./assignPromoter.vue?vue&type=template&id=aca687d2&scoped=true"
import script from "./assignPromoter.vue?vue&type=script&lang=js"
export * from "./assignPromoter.vue?vue&type=script&lang=js"
import style0 from "./assignPromoter.vue?vue&type=style&index=0&id=aca687d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca687d2",
  null
  
)

export default component.exports